import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { saveCrew, resetCrew } from "../../../actions/crew-kanban";
import { isToday, usePermission } from "../../../helpers/common";

const ActionButton = props => {
    const history = useHistory();
    const { farmId, isRequestingSave, haveChanges, isAssignCrewCall } = props;
    const back = () => history.push(`/home/farm/${farmId}/map/crew?sub=1`);
    const onSave = () => props.actions.saveCrew();
    const onReset = () => props.actions.resetCrew();
    const allow = usePermission();
    const isAllowEdit = allow("crew", "edit") ? isToday(props.search.range) : false;

    return <>
        {(haveChanges && !isRequestingSave) && isAllowEdit &&
            <Button variant="outline-primary" size="sm" className="mr-3 float-right"
                title="Reset" onClick={onReset}>
                <i className="fa fa-refresh mr-1" />Reset
            </Button>}
        {isAllowEdit && <Button variant="primary" size="sm" className="mr-3 float-right" title="Save"
            disabled={isAssignCrewCall || isRequestingSave || !haveChanges} onClick={onSave}>
            <i className="fa fa-floppy-o mr-1"></i> {isRequestingSave ? "Saving..." : "Save"}
        </Button>}
        <Button variant="danger" size="sm" className="mr-3 float-right" title="Cancel"
            disabled={isRequestingSave} onClick={back}>
            <i className="fa fa-times-circle mr-1"></i> Cancel
        </Button>
    </>;
};

const mapStateToProps = state => ({
    isRequestingSave: state.crewKanban.isRequestingSave,
    farmId: state.crewKanban.filters.farmId,
    crewList: state.crew.crewList,
    haveChanges: Object.keys(state.crewKanban.crews).length > 0 ?
        Object.keys(state.crewKanban.crews)
            .map(id => state.crewKanban.crews[id])
            .filter(e => e && e.isChanged).length > 0 : false,
    search: { range: state.analyze.searchParams.range },
    isAssignCrewCall: state.crewKanban.isAssignCrewCall
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ saveCrew, resetCrew }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ActionButton);